/**
 * Routes that put credentials in the URL query string.
 * Analytics must not init/track here — third parties receive the full URL
 * (and Mixpanel also spreads search params onto page-view events).
 */
export const CREDENTIAL_BEARING_PATHS = [
  "/tn/preview",
  "/rocket-lawyer-interview",
  "/rocket-lawyer-interview-dev",
]

/** Query keys that must never be forwarded to analytics. */
export const CREDENTIAL_QUERY_PARAMS = ["token", "serviceToken"]

export function normalizePathname(pathname) {
  if (!pathname || typeof pathname !== "string") return ""
  const trimmed = pathname.replace(/\/+$/, "")
  return trimmed || "/"
}

export function isCredentialBearingPath(pathname) {
  const normalized = normalizePathname(pathname)
  if (!normalized) return false
  return CREDENTIAL_BEARING_PATHS.some(
    (path) => normalized === path || normalized.startsWith(`${path}/`)
  )
}

export function omitCredentialQueryParams(params = {}) {
  const omitted = { ...params }
  for (const key of CREDENTIAL_QUERY_PARAMS) {
    delete omitted[key]
  }
  return omitted
}
